import { Routes } from '@angular/router'
import { RegisterComponent } from './modules/register/register.component'
import { unsavedChangesGuard } from '../core/guards/unsaved-changes.guard'
import { PaymentSuccessComponent } from './modules/stripe/payment-success/payment-success.component'
import { PaymentErrorComponent as PaymentCancelComponent } from './modules/stripe/payment-cancel/payment-cancel.component'
import { EngineerTrackingComponent } from './modules/engineer-tracking/engineer-tracking.component'
import { CallbackComponent } from './modules/callback/callback.component'
import { AccessDeniedComponent } from './modules/access-denied/access-denied.component'
import { EngineerAppCallbackComponent } from './modules/engineer-app-callback/engineer-app-callback.component'

export const PUBLIC_ROUTES: Routes = [
    { path: 'register', component: RegisterComponent, canDeactivate: [unsavedChangesGuard], title: 'Register' },
    { path: 'stripe/payment-success', component: PaymentSuccessComponent },
    { path: 'stripe/payment-cancel', component: PaymentCancelComponent },
    { path: 'engineer-tracking/:id', component: EngineerTrackingComponent },
    { path: 'callback', component: CallbackComponent, title: 'Authentication Callback' },
    { path: 'access-denied', component: AccessDeniedComponent, title: 'Access Denied' },
    { path: 'engineer-app-callback', component: EngineerAppCallbackComponent },
]
